<template>
    <a  style="color: #333c4a;"><i class="fa fa-trash-o" @click="delItem"></i></a>
</template>

<script>
  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../../store/mutation-types'
  export default {
    props: ['product'],
    data () {
      return {
        cart: this.$store.state.cart
      }
    },
    methods: {
      delItem (id) {
        if (this.product.PackageID != undefined)
        {
            var pkg = this.product.PackageID;
            var pakitems = [];

            for (var s = 0; s < this.cart.length; s++)
            {
                if (this.cart[s].PackageID == pkg)
                {
                  pakitems.push (this.cart[s]);
                }
            }
          
            for (var p = 0; p < pakitems.length; p++)
            {
                this.$store.commit(REMOVE_FROM_CART, pakitems[p]);
            }
           
        }
        else
        {
            this.$store.commit(REMOVE_FROM_CART, this.product);
        }
        
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cart/CartDelButton.vue